import { TFunction } from "i18next";
import moment from "moment";

/**
 * Obtiene el rango de fechas de un mes actual
 * @returns { start: Date; end: Date }
 */
const getMonth = (): { start_date: Date; end_date: Date } => {
	let date = new Date();
	let year = date.getFullYear();
	let month = date.getMonth();

	let start = moment(new Date(year, month, 1));
	let end;

	if (month + 1 > 11) {
		end = moment(new Date(year + 1, 0, 1)).subtract(1, "days");
	} else {
		end = moment(new Date(year, month + 1, 1)).subtract(1, "days");
	}

	return {
		start_date: start.toDate(),
		end_date: end.toDate(),
	};
};

/**
 * Obtiene atajos de rango de fechas
 */
const shortcuts = (t: TFunction<"translation", undefined>): { label: string; getValue: () => [moment.Moment, moment.Moment] }[] => {
	return [
		{
			label: t("utils.date.ranges.last_week"),
			getValue: () => {
				const start = moment().subtract(1, "weeks").startOf("week");
				const end = moment().subtract(1, "weeks").endOf("week");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.this_week"),
			getValue: () => {
				const start = moment().startOf("week");
				const end = moment().endOf("week");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.next_week"),
			getValue: () => {
				const start = moment().add(1, "weeks").startOf("week");
				const end = moment().add(1, "weeks").endOf("week");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.yesterday"),
			getValue: () => {
				const start = moment().subtract(1, "days").startOf("day");
				const end = moment().subtract(1, "days").endOf("day");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.today"),
			getValue: () => {
				const start = moment().startOf("day");
				const end = moment().endOf("day");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.tomorrow"),
			getValue: () => {
				const start = moment().add(1, "days").startOf("day");
				const end = moment().add(1, "days").endOf("day");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.yesterday_today_tomorrow"),
			getValue: () => {
				const start = moment().subtract(1, "days").startOf("day");
				const end = moment().add(1, "days").endOf("day");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.last_7_days"),
			getValue: () => {
				const start = moment().subtract(7, "days").startOf("day");
				const end = moment().endOf("day");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.next_7_days"),
			getValue: () => {
				const start = moment().startOf("day");
				const end = moment().add(7, "days").endOf("day");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.last_30_days"),
			getValue: () => {
				const start = moment().subtract(30, "days").startOf("day");
				const end = moment().endOf("day");
				return [start, end];
			},
		},
		{
			label: t("utils.date.ranges.next_30_days"),
			getValue: () => {
				const start = moment().startOf("day");
				const end = moment().add(30, "days").endOf("day");
				return [start, end];
			},
		},
	];
};

/**
 * Crea una lista de días entre dos fechas
 * @param date1 comienzo
 * @param date2 final
 * @returns string[] lista de días en formato YYYY-MM-DD
 */
const daysBetween = (date1: moment.Moment, date2: moment.Moment): string[] => {
	if (date2) {
		let clone = date1.clone();
		const days = [];

		while (clone.isSameOrBefore(date2)) {
			days.push(clone.format("YYYY-MM-DD"));

			clone.add(1, "days");
		}

		return days;
	} else {
		return [date1.format("YYYY-MM-DD")];
	}
};

const rangeOverlap = (start1: moment.Moment, end1: moment.Moment, start2: moment.Moment, end2: moment.Moment): boolean => {
	return start1.isBefore(end2) && start2.isBefore(end1);
};

export {
	shortcuts,
	getMonth,
	daysBetween,
	rangeOverlap,
};
